export const isChromiumBased = (userAgent: string): boolean =>
    Boolean(/Chrome|Chromium|CriOS/.exec(userAgent));
